import React, { Component } from 'react'
// import NameReferralForm from '../FamilyReferrals/FamilyReferralNew.jsx'
import { combineNames, /*FieldCol, FamilyReferralStatusOptions */} from '../FamilyReferrals/FamilyReferralHelpers.jsx'
import Modal from '../../components/Modal/Modal'
import ProgramTabs from './ProgramTabs'
import YSpinner from '../../elements/Spinner/Spinner'
import { GetFamiliesInProgramNameListEPmbo /*GetFamilyNameListEPmbo*/ } from '../../variables/Config' 
import { DigmaEntity } from '../../variables/DigmaDef'
import { teamMembers, familyProgramStatus } from '../../variables/ComboValues'


// Generate grid list / index of all referral names
export class Programi extends Component {
    constructor(props) {
        super(props);
        this.state = { showme: false, isLoading: true }
    }
    handleShow = (ev, mykey) => {
        ev.preventDefault()
        this.props.curFamily(mykey) // tell parent which is current family
        this.setState({ showme: true })
    }
    handleHide = (ev) => {
        ev.preventDefault()
        this.setState({ showme: false })
    }
    render() {
        const { referral, mykey, mbouser, active } = this.props;
        
        if (this.state.showme)
            return (
                <Modal root={document.getElementById('modal-root')}>
                    <button className="close-modal-button" onClick={(event) => this.handleHide(event)}>סגור חלון משפחה</button>

                    <div id={'r-' + mykey} className="family-form-display modal family-form-inner">
                        <ProgramTabs mbouser={mbouser} cptId={referral['id']} mteamMember = {this.props.mteamMember} />
                    </div>
                </Modal>
            )
        else {
            
            if (referral === undefined) {
                console.log("Programi ERROR - referral undfefined")
                return (<div key={mykey} className="referral-i" onClick={(event) => this.handleShow(event, mykey)}>undefined</div>)
            }

            let family = referral['f']
            let woman = referral['w']
            let man = referral['m']
            let status = referral['s']

            let fclass = active === mykey ? "referral-i active" : "referral-i"

            return (<div key={mykey} className={fclass} onClick={(event) => this.handleShow(event, mykey)}>
                { combineNames(family, woman, man, status)}
            </div>)
        }
    }
}

// main referral index component
// gets the data & use components to display it
export class FamilyProgramBody extends Component {
    constructor(props) {
        super(props)
        const { mbouser } = this.props
        this._isMounted = false

        this.state = {
            rlist: [],
            referrals: [], restresponse: [], restError: "",
            filter: "", isLoading: true,
            filterbymember: teamMembers.includes(mbouser.user_display_name) ? mbouser.user_display_name : "", 
            filterbystatus: "",
            showModal: false, modalRoot: ""
        }
    }

    newFetch(url){
        fetch(url ,{headers: {'Accept-Encoding' : 'gzip'}} )
       // fetch(url)
            .then(response => {
                if (response.ok) {
                    if (!this._isMounted) return null
                    return response.json()
                } else
                    throw new Error('newFetch: Something went wrong ... ')
            })
            .then(rlist => {
                /*rlist.sort(function (a, b) {
                    if (a['f'] > b['f'])
                        return 1
                    if (a['f'] < b['f'])
                        return -1
                    return 0
                })*/
                if (!this._isMounted) return null
                if (rlist.includes("Fail to find digma families"))
                    rlist = []
                this.setState({ rlist, isLoading: false, active: "" })
                return true; // void - no one is looking...
            })
            .catch(restError => this.setState({ restError: restError, isLoading: false }))
    }
    currentFamily = (x) => {
         this.setState({active: x})
    }

    componentDidMount() {
        this._isMounted =true

        this.setState({modalRoot: document.getElementById('modal-root')})

        //this.newFetch("http://digmame/wp-json/mbo/v3/families") //GetFamiliesInProgramNameListEPmbo
        //this.newFetch(GetFamiliesInProgramNameListEPmbo) //families
        this.newFetch(this.props.families) //families
        //this.newFetch(GetFamilyNameListEPmbo) 
    }
    componentWillUnmount(){
        this._isMounted = false
    }
    filter = (e) => {
        e.preventDefault()
        //this.setState({ filter: e.target.value, filterbystatus: "" })
        this.setState({ filter: e.target.value })
    }
    filterbymember = (e) => {
        e.preventDefault()
        // console.log('event', e);{/*<Spinner />*/}
        //this.setState({ filterbystatus: e.target.value, filter: "" })
        this.setState({ filterbymember: e.target.value })
    }
    filterbystatus = (e) => {
        e.preventDefault()
        // console.log('event', e);{/*<Spinner />*/}
        //this.setState({ filterbystatus: e.target.value, filter: "" })
        this.setState({ filterbystatus: e.target.value })
    }
    findFamilyById = (array, id) => {
        return array.find((element) => {
          return element.id === id;
        })
    }
    mteamMember = (tmember, infoTab) => {
        //console.log('mteamMember = ', tmember, infoTab)
        //console.log('mteamMember this.state.rlist= ', this.state.rlist)
        let newRlist = [...this.state.rlist]
        newRlist.forEach(item => {
            if (item.id === parseInt(infoTab.program_code)){
                if (item.t === tmember) return // no need for extra work
                //console.log('mteamMember fOUnd item= ', item)
                item.t = tmember
            }
        })
        
        this.setState({ rlist: newRlist })
    }

    render() {
        const {rlist, isLoading, restError, filterbystatus, filterbymember, filter, active }= this.state

        if (isLoading)
            return (<YSpinner />)
        if (restError !== "")
            return <h2>תקלה חולפת: {restError}</h2>
        // console.log("Rest response- this state", flist)
        // apply filetrs
        var flist  = [...rlist] // Object.assign(rlist) 

        if (flist.length > 0){
            if (filterbystatus) {
                // console.log("filterbystatus", this.state.filterbystatus)
                if (filterbystatus === 'לא מוגדר')
                    flist = flist.filter(item => {return !familyProgramStatus.includes(item['s'])})
                else flist = flist.filter(item => item['s'].includes(filterbystatus))
            }
            if (filterbymember) {
                if (filterbymember === 'לא מוגדר')
                    flist = flist.filter(item => {return !teamMembers.includes(item['t'])})
                else
                    flist = flist.filter(item => item['t'].includes(filterbymember))
            }
            if (filter) {
                //console.log("Filter items", items)
                flist = flist.filter(item => item['f'].includes(filter) 
                    || item['w'].includes(filter) || item['m'].includes(filter))
            }
        }

        return (
            <div id="main-win">
                <h3 className="table-header">אינדקס {DigmaEntity} בתכנית ({flist.length})</h3>

                <div className="yahav-index-families" >
                    <span>&nbsp;&nbsp;</span>
                    <input id="filter-by-name" type="text" value={filter} 
                                        onChange={this.filter} placeholder="חיפוש לפי שם..." />
                    <span>&nbsp;&nbsp;סטטוס משפחה: </span>
                    <select onChange={this.filterbystatus} value={filterbystatus} >
                        <option value="" key="empty" >כל המשפחות</option>
                        {familyProgramStatus.map(item => <option key={item} value={item} >{item}</option>)}
                        
                        <option value="לא מוגדר" key="לא מוגדר" >לא מוגדר</option>                       
                    </select>
                    <span>&nbsp;&nbsp;</span>
                    <select onChange={this.filterbymember} value={filterbymember} >
                        <option value="" > מלווה משפחה:  כולם</option>
                        {teamMembers.map(item => <option key={item} value={item} >{item}</option>)}  
                        <option value="לא מוגדר" >לא מוגדר</option>                                       
                    </select>
                    <br /><br />
                    <div className="yahav-index-families-items">
                        {flist.length === 0 ? <h3>לא נמצאו משפחות, נסה/י חיפוש אחר</h3>
                            : flist.map((item) => {
                                //console.log('families RLIST item=', rlist)
                                if (item['id'] === undefined) 
                                    return null
                                //console.log('families index='+ index + '  item=', item)

                                return <Programi key={item['id']} cptId={item['id']} 
                                                    mykey={item['id']} referral={item}
                                                    curFamily = {this.currentFamily}
                                                    active = {active}
                                                    mteamMember = {this.mteamMember}
                                                    mbouser={this.props.mbouser}  />
                            }, this)
                        }
                    </div>
                </div>
            </div>
        )
    }
}
class FamilyProgramIndex extends React.PureComponent {
    render() {
        return (
            <div>
                <div id="modal-root"></div>
                <FamilyProgramBody mbouser={this.props.mbouser} families={ GetFamiliesInProgramNameListEPmbo() } />
            </div>
        )
    }
}
export default FamilyProgramIndex;
